import logo from "../../Images/logo.png";
import {
  Facebook,
  Twitter,
  Instagram,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#333333] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="lg:col-span-1">
          <div className="flex items-center mb-4">
            <img
              src={logo || "/placeholder.svg"}
              className="h-14"
              alt="Semars Logo"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo Column */}

          {/* Home Column */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              <a href="/home">Home</a>
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/about-us"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/founder-message"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Founder's Message
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/industries-we-serve"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Industries We Serve
                </a>
              </li>
              <li>
                <a
                  href="/invesment-opportunities"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Investment Opportunities
                </a>
              </li>
              <li>
                <a
                  href="/research-development"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Research and Development
                </a>
              </li>
              <li>
                <a
                  href="/events-conference"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Events & Conferences
                </a>
              </li>
            </ul>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              <a href="/services">Services</a>
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/services"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Market Entry & Advisory
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Legal & Compliance
                </a>
              </li>
              <li>
                <a
                  href="/invesment-opportunities"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Investment Opportunities
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  R&D Support
                </a>
              </li>
            </ul>
          </div>

          {/* Help Column */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              <a href="/contact">Help</a>
            </h3>
            <ul className="space-y-2 ">
              <li>
                <a
                  href="/contact"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Terms of Use
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-[#FFFFFF] hover:text-[#C99C48] transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contacts & Social Media Column */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contacts</h3>
            <div className="space-y-2">
              <div className="flex items-start">
                <MapPin className="w-5 h-5 text-[#C99C48] mr-3 mt-1 flex-shrink-0" />
                <span className="text-[#FFFFFF]">
                  Jeddah, Kingdom of Saudi Arabia
                </span>
              </div>
              {/* <div className="flex items-center">
                <Phone className="w-5 h-5 text-[#C99C48] mr-3 flex-shrink-0" />
                <span className="text-[#FFFFFF]">+966 (Insert Number)</span>
              </div> */}
              <div className="flex items-center">
                <Mail className="w-5 h-5 text-[#C99C48] mr-3 flex-shrink-0" />
                <span className="text-[#FFFFFF]">info@semarsholding.com</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-center">
              Social Media
            </h3>
            <div className="flex space-x-4 justify-center">
              <a
                href="/"
                className="bg-[#C99C48] rounded-full p-2 flex items-center justify-center hover:opacity-80 transition-opacity"
              >
                <Twitter className="w-5 h-5 text-black" />
              </a>
              <a
                href="/"
                className="bg-[#C99C48] rounded-full p-2 flex items-center justify-center hover:opacity-80 transition-opacity"
              >
                <Facebook className="w-5 h-5 text-black" />
              </a>
              <a
                href="/"
                className="bg-[#C99C48] rounded-full p-2 flex items-center justify-center hover:opacity-80 transition-opacity"
              >
                <Instagram className="w-5 h-5 text-black" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 text-center">
          <p className="text-[#FFFFFF]">
            Copyright © 2025. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;